import React from 'react';
import styled from 'styled-components';
import { mobileMediaQuery } from '../../../Theming';
import { SvgProps } from '../core';

const StyledSVG = styled.svg`
  ${mobileMediaQuery} {
    margin-left: 25px;
    width: 105.16px;
    height: 112.19px;
  }
`;

const KeepDataSafe: React.FC<SvgProps> = ({
  width = 169,
  height = 204,
  className,
}) => {
  return (
    <StyledSVG
      width={width}
      height={height}
      className={className}
      viewBox="0 0 169 204"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M93.8881 179.128C131.777 153.441 150.22 130.756 150.22 112.206V93.5047H93.8881V179.128ZM75.1106 179.128V93.5047H18.7779V112.206C18.7779 130.756 37.2225 153.441 75.1098 179.128H75.1106ZM18.7779 74.8031H75.1098V19.1848C57.8911 20.9589 40.5345 27.6151 22.9583 39.2834C21.672 40.1372 20.6173 41.2941 19.8878 42.6514C19.1583 44.0087 18.7767 45.5244 18.7766 47.0639L18.7779 74.8031ZM93.8877 19.184V74.8031H150.22V47.0639C150.22 45.5243 149.838 44.0087 149.108 42.6514C148.379 41.2941 147.324 40.1372 146.038 39.2834C128.464 27.6171 111.108 20.9589 93.8881 19.1848L93.8877 19.184ZM168.998 112.205C168.998 140.529 143.79 169.667 94.6309 201.044C91.607 202.974 88.0907 204 84.499 204C80.9073 204 77.3909 202.974 74.367 201.044C25.2078 169.668 0 140.53 0 112.206V47.0639C1.05924e-05 42.4453 1.1451 37.8981 3.33361 33.8262C5.52211 29.7542 8.68631 26.2834 12.5453 23.7219C36.2687 7.97544 60.2989 0 84.4996 0C108.7 0 132.73 7.97544 156.455 23.7219C160.314 26.2834 163.478 29.7543 165.666 33.8264C167.855 37.8984 169 42.4456 169 47.0643L168.998 112.205Z"
        fill="#89C8AA"
      />
    </StyledSVG>
  );
};

export default KeepDataSafe;
